import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';

import { Receber, ReceberLista, ReceberListaFiltros } from '@app/models/receber.model';
import { RealizarRecebimento } from '@app/models/realizar-recebimento';
import { PesquisaRelatorio } from '@app/models/pesquisa-relatorio';
import { Baixa } from '@app/models/baixa.model';
import { ReceberQuitarDados } from '../pages/financeiro/receber/receber-lista/receber-quitar-dados';

@Injectable()
export class ReceberService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  gravar(receber: Receber): Observable<any> {
    return this.http.post<any>(this.URL_API + 'receber', receber).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  quitar(quitarDados: ReceberQuitarDados): Observable<any> {
    return this.http
      .post<boolean>(this.URL_API + 'receber/quitar', quitarDados)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  desquitar(desquitarDados: ReceberQuitarDados): Observable<any> {
    return this.http
      .post<boolean>(this.URL_API + 'receber/desquitar', desquitarDados)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `receber/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `receber/${id}`);
  }

  obterTodos(): Observable<any> {
    return this.http.get<any>(this.URL_API + 'receber');
  }

  obterLista(filtro: ReceberListaFiltros): Observable<any> {
    return this.http.post<any>(this.URL_API + 'receber/lista', filtro, { headers: { meta: ['search'] } });
  }

  obterListaProcesso(filtro: ReceberListaFiltros): Observable<any> {
    return this.http.post<any>(this.URL_API + 'receber/listaProcesso', filtro, { headers: { meta: ['search'] } });
  }

  obterParciais(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `receber/obterParciais/?id=${(id)}`);
  }

  realizarRecebimento(realizarRecebimento: RealizarRecebimento): Observable<any> {
    return this.http.post<any>(this.URL_API + 'receber/realizarRecebimento', realizarRecebimento).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  realizarEstorno(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `receber/realizarEstorno/?id=${(id)}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  realizarAgrupamento(idProcesso: number, valorRecebido: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `receber/realizarAgrupamentoRecebimento/?idProcesso=${(idProcesso)}
                                                &valorRecebido=${(valorRecebido)}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }
  // TODO: o método no api estava comentado (?)


  obterTotalReceberPorProcesso(processoId: number, pesquisa: PesquisaRelatorio): Observable<any> {
    pesquisa.ProcessoId = processoId;
    return this.http.post<any>(this.URL_API + 'financeiro/processo/obterTotalReceberPorProcesso', pesquisa);
  }

  gerarFaturas(id: number, qntParcelas: number, intervaloDias: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `receber/gerarFaturas/?id=${id}&qntParcelas=${qntParcelas}&intervaloDias=${intervaloDias}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  } // TODO: VERIFICAR NA API SE ESTÁ COMO POST OU GET, COLOCAR GET

  emitirRecibos(listaTitulos: Baixa[]) {
    const newTab = window.open();
    window.localStorage.removeItem('recibos');
    window.localStorage.setItem('recibos', JSON.stringify(listaTitulos));
    newTab.location.href = window.location.href.split('#')[0] + '/#/recibo-multiplo?recibos';
    // history.go(-1);
    // newTab.close();
  }

}
